import { Link } from 'react-router-dom';
import Reveal from '@/components/apple/Reveal';
import { img, projeto, type Projeto } from '@/lib/projetos';
import { Container, PillButton, SectionTitle } from '@/components/apple/ui';

const CLIENTES = ['Copergás', 'Sicoob', 'Prefeitura de Caruaru', 'Câmara de Ouricuri', 'Hotel Ibis', 'RodoNorte', 'Caruaru Shopping'];

function Card({ p, grande = false }: { p: Projeto; grande?: boolean }) {
  return (
    <Link
      to="/cases"
      className="group relative block overflow-hidden rounded-[18px] md:rounded-[24px] bg-[#F5F5F7]"
      aria-label={`${p.nome} — ${p.cidade}`}
    >
      <img
        src={img(p.capa, grande ? 1800 : 1000)}
        alt={p.alt}
        loading="lazy"
        decoding="async"
        className={`w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03] ${
          grande ? 'aspect-[4/3] md:aspect-[21/9]' : 'aspect-[4/3]'
        }`}
      />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/55 to-transparent pointer-events-none" />
      <div className="absolute left-5 bottom-5 md:left-7 md:bottom-6 text-white">
        <p className={`font-semibold tracking-[-0.025em] ${grande ? 'text-[22px] md:text-[32px]' : 'text-[20px] md:text-[24px]'}`}>
          {p.nome}
        </p>
        <p className="text-[13px] md:text-[14px] text-white/80">{p.cidade}</p>
      </div>
    </Link>
  );
}

export default function Destaques() {
  const principal = projeto(15); // Câmara de Vertentes
  const secundarios = [projeto(8), projeto(12)].filter(Boolean) as Projeto[];

  return (
    <>
      <section className="bg-white py-14 md:py-20" aria-label="Clientes atendidos">
        <Container>
          <p className="text-center text-[13px] text-[#6E6E73]">Quem já confiou na HomeOffice Premium</p>
          <ul className="mt-4 flex flex-wrap justify-center gap-x-6 md:gap-x-9 gap-y-2">
            {CLIENTES.map((c) => (
              <li key={c} className="text-[15px] md:text-[19px] font-semibold tracking-[-0.02em] text-[#6E6E73]">
                {c}
              </li>
            ))}
          </ul>
        </Container>
      </section>

      <section className="bg-white pt-16 md:pt-24 pb-24 md:pb-36">
        <Container>
          <Reveal>
            <SectionTitle
              eyebrow="Projetos"
              title="Projetos que falam por si."
              sub="Fotos reais de ambientes que entregamos, do plenário à sala de reuniões."
            />
          </Reveal>

          <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {principal && (
              <Reveal className="md:col-span-2">
                <Card p={principal} grande />
              </Reveal>
            )}
            {secundarios.map((p, i) => (
              <Reveal key={p.id} delay={i === 0 ? 1 : 2}>
                <Card p={p} />
              </Reveal>
            ))}
          </div>

          <div className="mt-12 text-center">
            <PillButton to="/cases" variant="dark">
              Ver todos os projetos
            </PillButton>
          </div>
        </Container>
      </section>
    </>
  );
}
